var _g, _path, _ellipse, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinInvitationNotSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4176 27.1391H11.5775V15.6191H15.4176V27.1391ZM24.8514 15.3116C27.4112 15.3118 29.2665 16.9637 29.2665 20.5091V27.1391H25.4264V20.9566C25.4264 19.4078 24.8765 18.3966 23.4814 18.3966C23.0497 18.3998 22.6288 18.5347 22.2764 18.7841C21.924 19.0335 21.6567 19.3855 21.5101 19.7916C21.41 20.0924 21.3671 20.4099 21.3826 20.7266V27.1266H17.5426C17.5426 27.1266 17.5426 16.6586 17.5426 15.6066H21.3826V17.2316C21.7315 16.6265 22.239 16.1273 22.8501 15.7891C23.4612 15.451 24.1535 15.2858 24.8514 15.3116ZM13.4975 10.0128C13.7785 9.98102 14.063 10.0084 14.3325 10.0941C14.6022 10.1799 14.8514 10.3218 15.0625 10.5103C15.2735 10.6987 15.4419 10.9298 15.5576 11.1878C15.6732 11.4461 15.7338 11.7262 15.7338 12.0091C15.7338 12.2921 15.6732 12.572 15.5576 12.8303C15.442 13.0885 15.2734 13.3194 15.0625 13.5078C14.8514 13.6964 14.6022 13.8383 14.3325 13.9241C14.063 14.0098 13.7785 14.0384 13.4975 14.0066C12.968 14.0066 12.4595 13.796 12.085 13.4216C11.7105 13.0471 11.5 12.5387 11.5 12.0091C11.5001 11.4798 11.7108 10.9722 12.085 10.5978C12.4595 10.2234 12.9679 10.0128 13.4975 10.0128Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.6801,
    cy: 7.68,
    rx: 7.6801,
    ry: 7.68,
    fill: "#702DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2637 3.2636C32.6151 2.91213 33.1856 2.91213 33.5371 3.2636L37.5371 7.2636C37.5911 7.31761 37.6354 7.3776 37.6729 7.44036C37.7101 7.50285 37.7413 7.56949 37.7627 7.64056C37.7969 7.75474 37.8079 7.87438 37.7959 7.99212C37.7824 8.12558 37.7383 8.24951 37.6729 8.35931C37.6354 8.42231 37.5913 8.48285 37.5371 8.53704L33.5371 12.537C33.1856 12.8885 32.6151 12.8885 32.2637 12.537C31.9122 12.1856 31.9122 11.6151 32.2637 11.2636L34.7266 8.80071H28.9004C28.4034 8.80071 28 8.39734 28 7.90032C28 7.40327 28.4033 6.99993 28.9004 6.99993H34.7266L32.2637 4.53704C31.9122 4.18558 31.9122 3.61508 32.2637 3.2636Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinInvitationNotSent);
export default __webpack_public_path__ + "static/media/linkedin-invitation-not-sent.29a8ed270cd6d3a36d2e9c21445ab0a0.svg";
export { ForwardRef as ReactComponent };